import {SelectOption} from 'src/app/components'
import {MallModel, StoreCategoryModel, StoreModel} from '../../directory/models'
import {CampaignModel} from './Campaign.model'
import {PaymentCategoryModel} from '../../settings/models/PaymentCategory.model'
import {PaymentMethodModel} from '../../settings/models/PaymentMethod.model'
import {ParticipantDetailModel} from './LuckyDraw.model'

type CashbackType = 'EXTRA_POINT' | 'MULTIPLICATION_POINT'
type DirectGiftDetermination = 'RANDOM' | 'CUSTOMER_SERVICE'
type QuotaType = 'PRIZE' | 'CUSTOMER'
type REWARD_TYPES = 'DIGITAL' | 'FISIK' | 'PARKING' | 'VALET' | 'PRODUCT' | 'STAMP'

export type SALES_PROMO_PRIZE_TYPE =
  | 'PRODUCT'
  | 'DIGITAL'
  | 'FISIK'
  | 'PARKING'
  | 'VALET'
  | 'STAMP'
  | 'EXTRA_POINT'

export const SALES_PROMO_PRIZE_TYPE_ARRAY: {value: SALES_PROMO_PRIZE_TYPE; label: string}[] = [
  {value: 'PRODUCT', label: 'Product'},
  {value: 'DIGITAL', label: 'E-Voucher'},
  {value: 'FISIK', label: 'Physical Voucher'},
  {value: 'PARKING', label: 'Free Parking'},
  {value: 'VALET', label: 'Valet Parking'},
  {value: 'STAMP', label: 'Stamp'},
  {value: 'EXTRA_POINT', label: 'Extra Point'},
]

export interface CampaignSalesPromo {
  id?: string
  campaign_id?: string
  is_direct_cashback_point?: boolean
  is_mission_collect_stamp?: boolean
}

export interface SalesPromoModel extends CampaignModel {
  campaign_id?: string
  category?: string
  name?: string
  directory_ids?: (string | undefined)[]
  directories?: MallModel[]
  campaign_sales_promo?: CampaignModel
  is_direct_cashback_point?: boolean

  cashback_type?: CashbackType
  cashback_type_select?: SelectOption
  earn_point?: number
  point_multiplication?: number
  max_earn_point?: number

  direct_gift_determination?: DirectGiftDetermination
  // Conditional when is_direct_cashback_point = false and direct_gift_determination = CUSTOMER_SERVICE
  is_mission_collect_stamp?: boolean

  prize_quantity_per_round?: number
  total_stamp_per_round?: number
  max_stamp_per_day?: number
  max_round_per_customer?: number
  stamp_name?: string
  stamp_icon?: string
  stamp_success?: string

  image?: string
  thumbnail_image?: string
  text_on_popup_eng?: string
  text_on_popup_idn?: string
  tnc_eng?: string
  tnc_idn?: string
  is_draft?: boolean

  max_claim_per_day?: number
  max_claim_per_period?: number
  max_customer_per_day?: number
  quota_type?: QuotaType
  total_quota?: number
  max_daily_quota_earned?: number

  is_unlimited_claim_per_day?: boolean
  is_unlimited_claim_per_period?: boolean
  is_unlimited_customer_per_day?: boolean
  is_unlimited_daily_quota_earned?: boolean

  prizes?: SalesPromoPrizeModel[]
  prize_rules?: SalesPromoRuleModel[]
}

export interface SalesPromoPrizeModel extends PrizeListModel {
  remaining_quantity?: string
  valid_until?: string

  // Prize list in participant detail
  receipt_codes?: string[]
  prize_type?: SALES_PROMO_PRIZE_TYPE
  prize_name?: string
  is_mission_gift?: boolean
  status?: string
  claimed_at?: string
  claim_directory?: MallModel
}

export interface SalesPromoParticipant extends ParticipantDetailModel {
  total_receipt?: number
  total_point_earned?: number
  total_prize_earned?: number
  total_prize_claimed?: number
  total_expired_receipt?: number
  total_mission_completed?: number
  stamp_count?: number
  total_stamp_per_round?: number
  campaign_notes?: string
  mission_stamp_id?: string
  can_select_prize?: boolean
}
export interface SalesPromoRuleMasterModel {
  prize_rules: SalesPromoRuleModel[]
}

export interface SalesPromoRuleModel {
  id?: string
  name?: string
  merchant_category_ids?: string[]
  merchant_ids?: string[]
  merchants?: StoreModel[]
  merchant_categories?: StoreCategoryModel[]
  sales_promo_rules?: TransactionRule[]
}

export interface PrizeListModel {
  id?: string
  campaign_id?: string
  draw_directory_id?: string
  name?: string
  type?: string
  description_idn?: string
  description_eng?: string
  image?: string
  quantity?: number
  created_at?: string
  updated_at?: string
  directory?: MallModel
  draw_directory?: MallModel
  draw_date?: string
}

export interface TransactionRule {
  id?: string
  name?: string
  minimum_transaction?: number
  payment_category_ids?: string[]
  payment_method_ids?: string[]
  prizes?: PrizeRuleDetail[]
  payment_categories?: PaymentCategoryModel[]
  payment_methods?: PaymentMethodModel[]
  is_mixable?: boolean
  is_multiple_entry?: boolean

  is_combine_receipt?: boolean
  max_combine_receipt?: number
  min_combine_total_amount?: number
  days?: string[]
  is_multiplication_single_receipt?: boolean
  is_multiplication_combine_receipt?: boolean

  start_time?: string
  end_time?: string
}

export interface PrizeRuleDetail {
  id?: string
  prize_ids?: string[] // Optional because "CONSOLATION" prize has no prize_ids
  prizes?: PrizeListModel | PrizeListModel[]
  type?: REWARD_TYPES
  quantity?: number
  max_quantity_per_transaction?: number
  consolation_alias?: string
}

export interface SalesPromoSelectGiftModel {
  id?: string
  transaction_id?: string
  mission_stamp_id?: string
  prize_quantity_per_round?: number
  member_sales_promo_id?: string
  payment_category_names?: string[]
  payment_methods_names?: string[]
  is_combine_receipt?: boolean
  receipt_code?: string
  receipt_codes?: string[]
  point?: number
  amount?: number
  combine_amount?: number
  is_multiplication?: boolean
  chances?: number
  is_mixable?: boolean
  claim_directory?: MallModel
  prizes?: SalesPromoSelectGiftPrizesModel[]
}

export interface SalesPromoSelectGiftPrizesModel {
  id?: string
  campaign_id?: string
  is_random?: boolean
  random_pool_id?: string // send if campaign is random
  type?: SALES_PROMO_PRIZE_TYPE
  quantity?: number
  remaining_quantity?: number
  name?: string
  isDisabled?: boolean
  prizes?: SalesPromoSelectGiftPrizesModel[]
  is_locked?: boolean
  get_gift?: number
  max_gift?: number
}

export interface SalesPromoResultItem {
  name?: string
  quantity?: number
  member_code?: string
  fullname?: string
  phone_number?: string
  email?: string
  claimed_at?: string
  directory_name?: string
}

export interface SalesPromoResult {
  digital: SalesPromoResultItem[]
  physical: SalesPromoResultItem[]
  parking_valet: SalesPromoResultItem[]
  product: SalesPromoResultItem[]
  point: SalesPromoResultItem[]
}
